const default_state = "NY";

const states_list = [
  { state_code: "AL", state_name: "Alabama" },
  { state_code: "AK", state_name: "Alaska" },
  { state_code: "AZ", state_name: "Arizona" },
  { state_code: "AR", state_name: "Arkansas" },
  { state_code: "CA", state_name: "California" },
  { state_code: "CO", state_name: "Colorado" },
  { state_code: "CT", state_name: "Connecticut" },
  { state_code: "DE", state_name: "Delaware" },
  { state_code: "DC", state_name: "District of Columbia" },
  { state_code: "FL", state_name: "Florida" },
  { state_code: "GA", state_name: "Georgia" },
  { state_code: "HI", state_name: "Hawaii" },
  { state_code: "ID", state_name: "Idaho" },
  { state_code: "IL", state_name: "Illinois" },
  { state_code: "IN", state_name: "Indiana" },
  { state_code: "IA", state_name: "Iowa" },
  { state_code: "KS", state_name: "Kansas" },
  { state_code: "KY", state_name: "Kentucky" },
  { state_code: "LA", state_name: "Louisiana" },
  { state_code: "ME", state_name: "Maine" },
  { state_code: "MD", state_name: "Maryland" },
  { state_code: "MA", state_name: "Massachusetts" },
  { state_code: "MI", state_name: "Michigan" },
  { state_code: "MN", state_name: "Minnesota" },
  { state_code: "MS", state_name: "Mississippi" },
  { state_code: "MO", state_name: "Missouri" },
  { state_code: "MT", state_name: "Montana" },
  { state_code: "NE", state_name: "Nebraska" },
  { state_code: "NV", state_name: "Nevada" },
  { state_code: "NH", state_name: "New Hampshire" },
  { state_code: "NJ", state_name: "New Jersey" },
  { state_code: "NM", state_name: "New Mexico" },
  { state_code: "NY", state_name: "New York" },
  { state_code: "NC", state_name: "North Carolina" },
  { state_code: "ND", state_name: "North Dakota" },
  { state_code: "OH", state_name: "Ohio" },
  { state_code: "OK", state_name: "Oklahoma" },
  { state_code: "OR", state_name: "Oregon" },
  { state_code: "PA", state_name: "Pennsylvania" },
  { state_code: "RI", state_name: "Rhode Island" },
  { state_code: "SC", state_name: "South Carolina" },
  { state_code: "SD", state_name: "South Dakota" },
  { state_code: "TN", state_name: "Tennessee" },
  { state_code: "TX", state_name: "Texas" },
  { state_code: "UT", state_name: "Utah" },
  { state_code: "VT", state_name: "Vermont" },
  { state_code: "VA", state_name: "Virginia" },
  { state_code: "WA", state_name: "Washington" },
  { state_code: "WV", state_name: "West Virginia" },
  { state_code: "WI", state_name: "Wisconsin" },
  { state_code: "WY", state_name: "Wyoming" },
];

const getLocationFromIp = async () => {
  if (hasCustomerState()) {
    return;
  }

  await fetch("https://ip.flaviar.com/")
    .then((response) => response.json())
    .then(({ country, region_code = default_state }) => {
      setCustomerState(region_code);
    })
    .catch((error) => console.error("Error:", error));
};

const setCustomerState = (state) => {
  sessionStorage.setItem("state_global", state);
};

const getCustomerState = () => {
  return sessionStorage.getItem("state_global") ?? default_state;
};

const hasCustomerState = () => {
  return !!sessionStorage.getItem("state_global");
};

const createStateElement = ({ state_code, state_name }) => {
  let li = document.createElement("li");
  li.setAttribute("value", state_code);
  li.appendChild(document.createTextNode(state_name));
  return li;
};

const populateStateSelector = () => {
  const list = document.querySelector("#shopify-us-states");
  list.innerHTML = "";

  states_list.forEach(state => {
    list.appendChild(createStateElement(state));
  });

  document.querySelector(".getlocation").textContent = getCustomerState();

  registerStateSelectorEvents(list);
};

const registerStateSelectorEvents = (list) => {
  list.addEventListener("click", ({ target }) => {
    if (target && target.tagName === "LI") {
      setStateOnClick(target.getAttribute("value"));
    }
  });

  document
    .querySelector(".shipping-wrap")
    .addEventListener("click", openStateSelector);
  document.addEventListener("scroll", closeStateSelector);
  document.addEventListener("mouseup", closeStateSelector);
};

const setStateOnClick = (state) => {
  setCustomerState(state);

  if (location.pathname == "/search") {
    window.location.reload();
  } else {
    window.location = window.location.pathname;
  }
};

const closeStateSelector = (e) => {
  const container = document.querySelector(".menu-states");

  if (container && !container.contains(e.target)) {
    container.style.display = "none";
  }
};

const openStateSelector = (_) => {
  closeStatePopup();
  const container = document.querySelector(".menu-states");

  if (container.style.display == "none") {
    container.style.display = "block";
  }
};

const changeState = () => {
  openStateSelector();
};

const confirmState = () => {
  closeStatePopup();
};

const closeStatePopup = () => {
  const popup = document.querySelector("#state-selector-popup");

  if (!popup) {
    return;
  }

  popup.remove();
  sessionStorage.setItem("state_popup_dismissed", true);
  enableScroll();
};

const openStatePopup = ({ delay = 0 }) => {
  if (Shopify.designMode) {
    return;
  }

  if (sessionStorage.getItem("state_popup_dismissed")) {
    return;
  }

  const popup = document.querySelector("#state-selector-popup");

  if (!popup) {
    return;
  }

  popup.querySelectorAll(".selected-state").forEach((e) => {
    e.innerHTML = getCustomerState();
  });

  setTimeout(() => {
    disableScroll();
    popup.classList.remove("d-none");
  }, delay);
};

function disableScroll() {
  document.body.style.overflow = "hidden";
}

function enableScroll() {
  document.body.style.overflow = "initial";
}